import { Policy } from './policy';

export interface IAccessRights {
  userName: string;
  roles: string[];
  canCreate: boolean;
  canCreateLegacy: boolean;
  canRead: boolean;
  canReadHistory: boolean;
  canReadSoftDeleted: boolean;
  canUpdateBasic: boolean;
  canUpdateElevated: boolean;
  canDeleteSoft: boolean;
  canDeleteHard: boolean;
  canDeleteHardLegacy: boolean;
  canRestore: boolean;
  canImport: boolean;
  canCreateSwPartNumber: boolean;
  canDeleteSoftSwPartNumber: boolean;
  canDeleteSoftAndRestoreLegacy: boolean;
  canDownloadApiCallLogs: boolean;
  canCreateSwPartNumberSnapshot: boolean;
  canReleaseSwPartNumberSnapshot: boolean;
  canUpdateTranslations: boolean;
  canImportErrorCodes: boolean;
  canImportAlarmMasks: boolean;
  canCreateAfterSalesDtcReviewRequests: boolean;
  canCreateTechnicalOrganisationDtcReviewRequests: boolean;
  canDeleteAfterSalesDtcReviewRequests: boolean;
  canDeleteTechnicalOrganisationDtcReviewRequests: boolean;
  canUpdateInternalNotes: boolean;
  canMergeDtcReviewRequests: boolean;
  canDeleteDtcReviewRequests: boolean;
  canUpsertFieldHelp: boolean;
  canResetTrReviewFlags: boolean;
  canCreateNwNumber: boolean;
  canPublishSyncEvents: boolean;
}

export class AccessRights {
  private data: IAccessRights = {
    userName: '',
    roles: [],
    canCreate: false,
    canCreateLegacy: false,
    canRead: false,
    canReadHistory: false,
    canReadSoftDeleted: false,
    canUpdateBasic: false,
    canUpdateElevated: false,
    canDeleteSoft: false,
    canDeleteHard: false,
    canDeleteHardLegacy: false,
    canRestore: false,
    canImport: false,
    canCreateSwPartNumber: false,
    canDeleteSoftSwPartNumber: false,
    canDeleteSoftAndRestoreLegacy: false,
    canDownloadApiCallLogs: false,
    canCreateSwPartNumberSnapshot: false,
    canReleaseSwPartNumberSnapshot: false,
    canUpdateTranslations: false,
    canImportErrorCodes: false,
    canImportAlarmMasks: false,
    canCreateAfterSalesDtcReviewRequests: false,
    canCreateTechnicalOrganisationDtcReviewRequests: false,
    canDeleteAfterSalesDtcReviewRequests: false,
    canDeleteTechnicalOrganisationDtcReviewRequests: false,
    canUpdateInternalNotes: false,
    canMergeDtcReviewRequests: false,
    canDeleteDtcReviewRequests: false,
    canUpsertFieldHelp: false,
    canResetTrReviewFlags: false,
    canCreateNwNumber: false,
    canPublishSyncEvents: false,
  };

  constructor(data: IAccessRights | undefined) {
    if (data == undefined) return;

    this.data = data;
  }

  public authorized(policy: Policy | undefined): boolean {
    if (policy == undefined) return false;

    return (
      (policy == Policy.canCreate && this.data.canCreate) ||
      (policy == Policy.canCreateLegacy && this.data.canCreateLegacy) ||
      (policy == Policy.canRead && this.data.canRead) ||
      (policy == Policy.canReadHistory && this.data.canReadHistory) ||
      (policy == Policy.canReadSoftDeleted && this.data.canReadSoftDeleted) ||
      (policy == Policy.canUpdateBasic && this.data.canUpdateBasic) ||
      (policy == Policy.canUpdateElevated && this.data.canUpdateElevated) ||
      (policy == Policy.canDeleteSoft && this.data.canDeleteSoft) ||
      (policy == Policy.canDeleteHard && this.data.canDeleteHard) ||
      (policy == Policy.canDeleteHardLegacy && this.data.canDeleteHardLegacy) ||
      (policy == Policy.canRestore && this.data.canRestore) ||
      (policy == Policy.canImport && this.data.canImport) ||
      (policy == Policy.canCreateSwPartNumber && this.data.canCreateSwPartNumber) ||
      (policy == Policy.canDeleteSoftSwPartNumber && this.data.canDeleteSoftSwPartNumber) ||
      (policy == Policy.canDeleteSoftAndRestoreLegacy && this.data.canDeleteSoftAndRestoreLegacy) ||
      (policy == Policy.canDownloadApiCallLogs && this.data.canDownloadApiCallLogs) ||
      (policy == Policy.canCreateSwPartNumberSnapshot && this.data.canCreateSwPartNumberSnapshot) ||
      (policy == Policy.canReleaseSwPartNumberSnapshot && this.data.canReleaseSwPartNumberSnapshot) ||
      (policy == Policy.canUpdateTranslations && this.data.canUpdateTranslations) ||
      (policy == Policy.canImportErrorCodes && this.data.canImportErrorCodes) ||
      (policy == Policy.canImportAlarmMasks && this.data.canImportAlarmMasks) ||
      (policy == Policy.canCreateAfterSalesDtcReviewRequests && this.data.canCreateAfterSalesDtcReviewRequests) ||
      (policy == Policy.canCreateTechnicalOrganisationDtcReviewRequests &&
        this.data.canCreateTechnicalOrganisationDtcReviewRequests) ||
      (policy == Policy.canDeleteAfterSalesDtcReviewRequests && this.data.canDeleteAfterSalesDtcReviewRequests) ||
      (policy == Policy.canDeleteTechnicalOrganisationDtcReviewRequests &&
        this.data.canDeleteTechnicalOrganisationDtcReviewRequests) ||
      (policy == Policy.canUpdateInternalNotes && this.data.canUpdateInternalNotes) ||
      (policy == Policy.canMergeDtcReviewRequests && this.data.canMergeDtcReviewRequests) ||
      (policy == Policy.canDeleteDtcReviewRequests && this.data.canDeleteDtcReviewRequests) ||
      (policy == Policy.canUpsertFieldHelp && this.data.canUpsertFieldHelp) ||
      (policy == Policy.canResetTrReviewFlags && this.data.canResetTrReviewFlags) ||
      (policy == Policy.canCreateNwNumber && this.data.canCreateNwNumber) ||
      (policy == Policy.canPublishSyncEvents && this.data.canPublishSyncEvents)
    );
  }

  public get userName(): string {
    return this.data.userName;
  }
  public get roles(): string[] {
    return this.data.roles;
  }
}
